import { NextPageContext } from "next";
import { useSession } from "next-auth/react";

import ProtectedRoute from "components/protected-route";
import Queue from "components/queue";


export const QueuePage = ({ query, isProd: isProdOnLoad }) => {
  const { data: session, status } = useSession() ?? {};
  const loading = status === "loading";

  if (!loading && !session) {
    return <ProtectedRoute />;
  }

  return <Queue query={query} />;
};

QueuePage.getInitialProps = async ({ query, req }: NextPageContext) => {
  return { query };
};

export default QueuePage;
